import {
  Box, Typography, Chip, Divider, Collapse,
  IconButton, Paper, Grid
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
import Veg from '../../assets/veg.png';

const safe = (val) => val ?? "—";

const DetailRow = ({ label, value }) => (
  value ? (
    <Grid container alignItems="flex-start" sx={{ py: 1, borderBottom: "1px solid #f0f3f7" }}>
      <Grid item xs={5}>
        <Typography fontSize={12} color="#718198" fontWeight={500}>{label}</Typography>
      </Grid>
        <Grid item xs={1} /> {/* ✅ spacer column */}
      <Grid item xs={6}>
        <Typography fontSize={12} color="#384F6F" fontWeight={500}>{value}</Typography>
      </Grid>
    </Grid>
  ) : null
);

export default function ProductDetails({ productDetailsData }) {
    console.log("productDetailsData",productDetailsData)


  const [expanded, setExpanded] = useState(false);
  const d = productDetailsData;
  const offer = d?.offer_details;

  function calculateFinalPrice(item) {
  const mvOfferPrice = item?.mvOfferPrice || 0;
  const offerDetails = item?.offer_details;


  
  // ❌ No offer OR not a Discount coupon
  if (!offerDetails || offerDetails.couponType !== "Discount") {
    return mvOfferPrice;
  }

  const { flatTypeId, flatAmount } = offerDetails;

  let discount = 0;

  if (flatTypeId === 1) {
    // Flat amount (₹)
    discount = flatAmount || 0;
  } else if (flatTypeId === 2) {
    // Percentage (%)
    discount = (mvOfferPrice * (flatAmount || 0)) / 100;
  }

  const finalPrice = mvOfferPrice - discount;

  return Math.max(finalPrice, 0);
}

  const chipLabel = offer
    ? `${offer?.flatTypeId === 1 ? "₹" : ""}${offer?.flatAmount ?? ""}${offer?.flatTypeId === 2 ? "%" : ""}${
        offer?.couponType === "CashBack"
          ? " Cashback"
          : offer?.couponType === "Discount"
          ? " Off"
          : ""
      }`
    : "";

    const TrialPrice=calculateFinalPrice(productDetailsData)
    console.log("TrialPrice",TrialPrice,productDetailsData?.isSample==true)
  return (
    <div style={{ padding: "20px" }}>
      <Paper elevation={2} sx={{ borderRadius: 3, overflow: "hidden", boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.08)" }}>

        {/* Header */}
        <Box sx={{ px: 2.5, pt: 2.5, pb: 1.5, boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.08)" }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
            <Typography fontSize={18} fontWeight={600} color="#384F6F">
              {safe(d?.productName)}
            </Typography>
            <Box
              component="img"
              src={Veg}
              alt="veg"
              sx={{ width: 15, height: 15, objectFit: "contain" }}
            />
          </Box>
          <Typography fontSize={12} color="#718198" fontWeight={500}>
            {safe(d?.product_details?.packageWeight)} {safe(d?.product_details?.quantityType)}
          </Typography>
        </Box>

        <Divider sx={{ mx: 2.5 }} />

        {/* Price Section */}
        <Box sx={{ px: 2.5, py: 1.5 }}>
            {console.log("d?.isSample",d?.isSample)}
          {!offer ? (
            <Box display="flex" alignItems="center" gap={1.5}>
              <Typography fontSize={14} fontWeight={700} color="#384F6F">
              
                 ₹ {d?.mvOfferPrice ? d.mvOfferPrice.toFixed(2) : "—"} 
              </Typography>
              {d?.activeCount === 0 && (
                <Chip
                  label="Out of stock"
                  size="small"
                  sx={{ bgcolor: "#C71F1F", color: "white", fontSize: 10, fontWeight: 500 }}
                />
              )}
            </Box>
          ) : (
            <Box sx={{
              border: "1px solid #0091E6",
              borderRadius: 2,
              p: 1.5,
              position: "relative",
              overflow: "hidden"
            }}>
              {chipLabel && (
                <Box sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  background: "linear-gradient(135deg,#0091E6,#0073b7)",
                  color: "white",
                  fontSize: 10,
                  fontWeight: 700,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "0 8px 0 12px"
                }}>
                  {chipLabel}
                </Box>
              )}
              <Typography fontSize={10} color="#00B177" fontWeight={600} mb={0.5}>
                Only On App
              </Typography>
              <Box display="flex" alignItems="center" gap={1.5}>
                <Typography fontSize={14} fontWeight={700} color="#384F6F">
                    {console.log("trial----",productDetailsData?.isSample=="true")}
                     ₹{d?.isSample==true?calculateFinalPrice(productDetailsData).toFixed(2):d?.mvOfferPrice.toFixed(2) }
                 
                </Typography>
                <Typography fontSize={14} color="#aaa" sx={{ textDecoration: "line-through" }}>
                  ₹ {d?.mrp ? d.mrp.toFixed(2) : "—"}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        {/* Info Accordion */}
        <Box sx={{
          mx: 2.5,
          mb: 2.5,
          border: "1px solid #e8edf3",
          borderRadius: 2,
          overflow: "hidden"
        }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            onClick={() => setExpanded(!expanded)}
            sx={{
              px: 2,
              py: 1.5,
              cursor: "pointer",
              bgcolor: "#fafbfd",
              "&:hover": { bgcolor: "#f3f6fa" },
              transition: "background 0.2s"
            }}
          >
            <Typography fontSize={14} fontWeight={600} color="#384F6F">
              Info
            </Typography>
            <IconButton size="small" disableRipple sx={{ p: 0, color: "#384F6F" }}>
              {expanded
                ? <KeyboardArrowUpIcon fontSize="small" />
                : <KeyboardArrowDownIcon fontSize="small" />}
            </IconButton>
          </Box>

          <Collapse in={expanded}>
            <Divider />
            <Box sx={{ px: 2, py: 1 }}>
              <DetailRow label="Description" value={safe(d?.product_details?.description)} />
              <DetailRow label="Shelf Life" value={safe(d?.product_details?.shelfLife)} />
              <DetailRow label="Unit" value={`${safe(d?.product_details?.packageWeight)} ${safe(d?.product_details?.quantityType)}`} />
              <DetailRow label="HSN Code" value={safe(d?.product_details?.hsnCode)} />
              <DetailRow label="Quantity" value={`${safe(d?.product_details?.quantityValue)} ${safe(d?.product_details?.unit)}`} />
              <DetailRow label="Meal Types" value={safe(d?.product_details?.mealType)} />
              <DetailRow label="Brand Name" value={safe(d?.product_details?.brandName)} />
              <DetailRow label="Microwave Heating" value={d?.product_details?.microwaveHeatingRequired ? "YES" : "NO"} />
              <DetailRow label="FSSAI License" value={safe(d?.product_details?.fssaiNumber)} />
            </Box>
          </Collapse>
        </Box>

      </Paper>
    </div>
  );
}